module.exports = __webpack_public_path__ + "img/portfolio-link.f9133c6c.svg";